import type { ComponentPropsWithRef, ReactNode } from "react"

import type { JsonObject } from "@/types/json"

import {
  SimulationWrapper,
  SimulationWrapperType,
  type SimulationWrapperChangeHandler,
  type SimulationWrapperConfig,
} from "../types"
import { ApiBulkSetupButton } from "./ApiBulkSetupButton"
import { ApiTestCaseCell } from "./ApiTestCaseCell"

export class ApiSimulationWrapper extends SimulationWrapper {
  constructor() {
    super({
      type: SimulationWrapperType.API_WRAPPER,
      name: "Api",
      display_name: "API",
      metadata: {},
    })
  }

  render(): ReactNode {
    return (
      <div className="text-sm">
        <span className="font-medium">API Wrapper</span>
      </div>
    )
  }

  renderTopLevelConfig(
    config: SimulationWrapperConfig | null | undefined,
    onConfigChange: SimulationWrapperChangeHandler<SimulationWrapperConfig>,
    disabled?: boolean,
    onDraftOpen?: () => () => void,
  ): ReactNode {
    return (
      <ApiBulkSetupButton
        config={config}
        onChange={onConfigChange}
        disabled={disabled}
        onDraftOpen={onDraftOpen}
      />
    )
  }

  renderTestCaseCell(
    simulationMetadataInput: JsonObject | null | undefined,
    onUpdate: SimulationWrapperChangeHandler<JsonObject>,
    _isExpanded: boolean,
    width: string,
    disabled = false,
    cellProps?: ComponentPropsWithRef<"td">,
    onDraftOpen?: () => () => void,
  ): ReactNode {
    return (
      <ApiTestCaseCell
        simulationMetadataInput={simulationMetadataInput}
        onUpdate={onUpdate}
        width={width}
        disabled={disabled}
        cellProps={cellProps}
        onDraftOpen={onDraftOpen}
      />
    )
  }
}
